import React from 'react';
import AvatarGroup from '@atlaskit/avatar-group';
import Heading from '@atlaskit/heading';
import { Flex, Text } from '@atlaskit/primitives';
import { useIntl } from '@atlassian/jira-intl';
import { useGetUsersWithoutCustomRole } from '../../../../services/store/users-and-roles/index.tsx';
import { messages } from './messages.tsx';

export const StepTwo = () => {
	const { formatMessage } = useIntl();

	const [usersWithoutCustomRole] = useGetUsersWithoutCustomRole();

	if (usersWithoutCustomRole.data === null) {
		// Users should not see this screen if one of the requests is still loading or error
		throw new Error('StepTwo should not be rendered if users are still loading');
	}

	const avatarGroupData = usersWithoutCustomRole.data.values.map((user) => ({
		key: user.id,
		name: user.name,
		src: user.avatarUrl,
	}));

	return (
		<Flex direction="column" rowGap="space.300">
			<Flex rowGap="space.100" direction="column">
				<Heading size="xlarge">{formatMessage(messages.title)}</Heading>
				<Text>{formatMessage(messages.description)}</Text>
			</Flex>
			{usersWithoutCustomRole.data.values.length > 0 && (
				<Flex direction="column" rowGap="space.200">
					<Heading size="xsmall" as="div">
						{formatMessage(messages.usersNeedAdminRole, {
							userAmount: usersWithoutCustomRole.data.values.length,
						})}
					</Heading>
					<AvatarGroup appearance="stack" data={avatarGroupData} />
				</Flex>
			)}
		</Flex>
	);
};
